import t from "./highrise1287.mjs";
import m from "./highrise1288.mjs";
import s from "./highrise1289.mjs";
import i from "./highrise1290.mjs";
import f from "./highrise1291.mjs";
import p from "./highrise1292.mjs";
import e from "./highrise1293.mjs";
import J from "./highrise1294.mjs";
import a from "./highrise1295.mjs";
import c from "./highrise1296.mjs";
import d from "./highrise1297.mjs";
import h from "./highrise1298.mjs";
import R from "./highrise1299.mjs";
const r = {
  hr: {},
  da: t,
  nl: a,
  "en-US": s,
  fi: f,
  "fr-CA": p,
  "fr-FR": e,
  de: m,
  hu: {},
  it: J,
  no: c,
  "pt-BR": d,
  "pt-PT": h,
  es: i,
  sv: R
}, H = (n) => {
  const o = r[n];
  return o || r["en-US"];
};
export {
  H as createHighRiseStrings
};
